import type {Article} from '../types/article';

const isPhantomDarkEditorial = (article: Article): boolean =>
  article.isEditorial === true && article.tags.some((tag) => tag.toLowerCase() === 'phantom-dark');

const shuffled = (articles: readonly Article[], random: () => number): Article[] => {
  const result = [...articles];
  for(let index = result.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [result[index], result[swapIndex]] = [result[swapIndex] as Article, result[index] as Article];
  }
  return result;
};

export const composeHomepageArticles = (
  articles: readonly Article[],
  limit = 8,
  random: () => number = Math.random
): Article[] => {
  if(limit <= 0) return [];

  const availableEditorials = articles.filter(isPhantomDarkEditorial);
  const editorialCount = Math.min(availableEditorials.length, random() < 0.5 ? 2 : 3, limit);
  const phantomEditorials = shuffled(availableEditorials, random).slice(0, editorialCount);
  const groundedArticles = articles.filter((article) => !isPhantomDarkEditorial(article));
  const otherEditorials = articles.filter((article) => article.isEditorial && !isPhantomDarkEditorial(article));
  const generalArticles = [...groundedArticles.filter((article) => !article.isEditorial), ...otherEditorials]
    .slice(0, Math.max(0, limit - editorialCount));
  const composed = [...generalArticles];
  const positions = phantomEditorials.length === 3 ? [2, 5, 7] : phantomEditorials.length === 2 ? [2, 5] : [2];

  phantomEditorials.forEach((article, index) => {
    composed.splice(Math.min(positions[index] ?? composed.length, composed.length), 0, article);
  });

  return composed.slice(0, limit);
};
